/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $GraphicsBox, CanBeSignal, Trigger} from '@gongxigames/framework/core/fragments/BuilderY';
import {$BottomPanel} from './BottomPanel';
import {$TopPanel} from './TopPanel';
import {BetChangeAction} from './BetSelect';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
// import {WinMeterManagerTriggers} from './WinArea/WinMeterManager';

export type MainUiProps = {
    jurisdictionZoneHeight: CanBeSignal<number>;
    betList: CanBeSignal<number[]>;
    betCurrent: CanBeSignal<number>;
    balance: CanBeSignal<number>;
    betFormatted: CanBeSignal<string>;
    turboLevel: CanBeSignal<ReelsSpeedLevel>;
    soundEnabled: CanBeSignal<boolean>;

    onSoundBtn: () => void;
    onBetChangeBtn: BetChangeAction;
    onMenuBtn: () => void;
    onShowBetSelectBtn: () => void;
    onTurboBtn: () => void;
};

export const $MainUi: FC<MainUiProps> = (props: MainUiProps) => {
    return <$Container name='ruby_ui'>
        <$GraphicsBox
            responsive={{box: {width: '100%', height: '100%'}}}
            responsiveBoxSize
            boxColor={0xffffff}
            boxAlpha={0.5}
        />
        <$TopPanel/>
        <$BottomPanel {...props}/>
    </$Container>;
};